module.exports = __webpack_public_path__ + "static/media/order.344a6648.svg";